import _ from "lodash";

import {
  FETCH_STREAM,
  FETCH_STREAMS,
  DELETE_STREAM,
  CREATE_STREAM,
  EDIT_STREAM,
} from "../actions/types";
 
const streamReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_STREAM:
      return { ...state, [action.payload.id]: action.payload };
    case CREATE_STREAM:
      return { ...state, [action.payload.id]: action.payload };
    case EDIT_STREAM:
      return { ...state, [action.payload.id]: action.payload };
    ///////////
    case DELETE_STREAM:
      return _.omit(state, action.payload);
    case FETCH_STREAMS:
      return { ...state, ..._.mapKeys(action.payload, "id") };

    default:
      return state;
  }
};

export default streamReducer;
